<template>
  <vue-modal
    name="shareYourDesignModal"
    :pivotY="0.15"
    width="350px"
    height="auto"
    :scrollable="true"
    :classes="['generic-modals', 'v--modal', 'modals-share-your-design']"
    ref="vueModal"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <section class="modals-share-your-design">
      <div :class="[ 'modals-share-your-design-wrapper', { hide: !hideConfirmationModal } ]">
        <h2 class="modals-share-your-design-title">{{ translations.shareYourDesignTitle }}</h2>
        <div class="modals-share-your-design-text">
          {{ translations.shareYourDesignText1 }} <br />
          {{ translations.shareYourDesignText2 }}
        </div>
        <div class="modals-share-your-design-share-area">
          <button
            @click="copyLink"
            @mouseout="onMouseOut"
            :disabled="recipeIsLoading"
            class="modals-share-your-design-share-area-copy-link"
          >
            <span class="icon-share modals-share-your-design-share-area-copy-link-icon"></span>
            <span class="modals-share-your-design-share-area-copy-link-text">
              {{ translations.shareYourDesignCopyLink }}
            </span>
          </button>
          <div ref="copyMessage" class="modals-share-your-design-share-area-copy-message">{{ translations.shareYourDesignCopyLinkM }}</div>
        </div>
        <div class="large-12 columns">
          <form
            ref="form"
            class="modals-share-your-design-form"
            method="post"
            v-on:submit.prevent="sendMessage"
          >
            <div class="modals-share-your-design-form-modal-scroll-area">
              <div class="required-input">
                <input
                  type="text"
                  maxlength="64"
                  id="input_name"
                  :placeholder="translations.shareYourDesignName"
                  required
                  v-model="shareDesignFormData.from_name"
                />
                <span class="req">*</span>
              </div>
              <div class="required-input">
                <input
                  type="email"
                  maxlength="250"
                  id="input_email"
                  :placeholder="translations.shareYourDesignEmail"
                  required
                  v-model="shareDesignFormData.from_email"
                />
                <span class="req">*</span>
              </div>
              <div
                v-for="(recipient, index) in addAnotherRecipients"
                v-bind:key="index"
                class="modals-share-your-design-form-add-recipient-container"
              >
                <div :data-id="index" class="required-input">
                  <input
                    type="email"
                    maxlength="250"
                    :id="`input_recipients_${index}`"
                    :placeholder="translations.shareYourDesignRecipient"
                    required
                    v-model="recipient.emailAddress"
                  />
                  <div
                    class="modals-share-your-design-form-add-recipient-container-close"
                    v-if="index != 0"
                    @click="removeRecipient(index)"
                  >
                    <span class="icon-close"></span>
                  </div>
                  <span class="req">*</span>
                </div>
              </div>
              <div class="modals-share-your-design-form-add-another-area">
                <button
                  @click.stop.prevent="addRecipient"
                  class="add-another"
                >
                  <span class="icon-plus"></span
                  ><span class="add-another-text">{{
                    translations.shareYourDesignAddAnother
                  }}</span></button
                >&ensp;<span class="max-add-another-text">{{
                    translations.shareYourDesignMaxSize
                }}</span>
              </div>
              <textarea
                maxlength="2000"
                id="textarea_message"
                class="modals-share-your-design-form-textarea-message"
                :placeholder="translations.shareYourDesignMessage"
                v-model="shareDesignFormData.message"
              >
              </textarea>
            </div>
            <div class="modals-share-your-design-form-check">
              <label
                for="checkbox1"
                class="modals-share-your-design-form-check-label"
              >
                <input
                  id="checkbox1"
                  name="newsletter"
                  type="checkbox"
                  :checked="enableCheck"
                />
                <span> {{ translations.shareYourDesignCheckBoxM }} </span>
              </label>
            </div>
            <vue-recaptcha
              v-if="!recaptchaVerified && !!configuration.enableRecaptcha"
              id="recaptcha"
              ref="recaptchaShareCustomizer"
              :loadRecaptchaScript="true"
              :sitekey="recaptchaKey"
              @verify="onVerifyRecaptcha"
              @error="errorRecaptcha"
            >
            </vue-recaptcha>
            <div class="modals-share-your-design-form-button-wrapper">
              <button
                :disabled="disableSendButton"
                type="submit"
                id="submit_button"
                class="modals-share-your-design-form-send button primary"
              >
                {{ translations.shareYourDesignSend }}
              </button>
            </div>
          </form>
        </div>
        <button
          class="close-button"
          id="close-button-shareYourDesignModal"
          title="Close"
          @click="closeModal"
        >
          <span class="icon-close"></span>
        </button>
      </div>
      <div
        :class="[
          'modals-share-your-design-message-sent',
          { hide: hideConfirmationModal }
        ]"
      >
        <h2 class="modals-share-your-design-message-sent-title-text">
          {{ translations.shareYourDesignSendMessage }}
        </h2>
        <div class="modals-share-your-design-message-sent-design-text">
          {{ translations.shareYourDesignSendText }}
        </div>
        <button
          class="close-button"
          id="close-button-message-shareYourDesignModal"
          title="Close"
          @click="closeModal"
        >
          <span class="icon-close"></span>
        </button>
      </div>
    </section>
  </vue-modal>
</template>

<script>

import VueRecaptcha from 'vue-recaptcha';
import { recaptchaHost } from '@/data/constants';
import shareYourDesign from "@/mixins/ShareYourDesign";

export default {
  name: "ShareYourDesignModal",
  components: { VueRecaptcha },
  mixins: [shareYourDesign],
  props: {
    /**
     * Enable or Disabled the CheckBox for Newsletter
     */
    enableCheck: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if(window.grecaptcha && !window.__recaptcha_api?.includes(recaptchaHost)) {
      window.grecaptcha = {};
    }
  }
};
</script>
